<template>
  <div class="home-box">
    <div class="title" @click="exit"><i class="el-icon-back"></i> 党建活动</div>
    <div class="box">
      <div class="box-title">
        <div v-if="isMenuExit('pro:party:edit')" class="btn1" @click="enter">编辑</div>
        <div v-if="isMenuExit('pro:party:del')" class="btn2" @click="deleteByIdNew">删除</div>
      </div>
      <div class="box-cont">
        <div
          style="
          margin-top:26px;
          font-family: SourceHanSansCN-Regular;
          font-size: 30px;
          font-weight: normal;
          letter-spacing: 0em;
          color: #666666;">{{data.newsTitle}}</div>
        <div 
          v-html="data.newsContent"
          style="
          font-family: SourceHanSansCN-Regular;
          font-size: 20px;
          font-weight: normal;
          letter-spacing: 0em;
          color: #999999;
          padding:16px;
          text-align:start"></div>
          <div class="imgList">
        <el-image 
          style="width: 13vw; height: 17.7vh;margin-left: 16px;
          margin-top: 8vh;"
          v-for="(item,index) in data.imgContent"
          :key="index"
          :src="item" 
          :preview-src-list="[item]">
        </el-image>
      </div>
      </div>
      <div class="box-b">
        <div class="ll">
          <div>{{data.newsType}}</div>
          <div>{{data.createDate}}</div>
          <div>{{data.personCount}}参与</div>
        </div>
        <div class="rr">
          {{data.viewCount}} 浏览
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import base from '../../../untils/base'
import myHttp from '../../../untils/port'
import util from '../../../untils/util'
  export default {
    data() {
      return {
        typeList: [
          {
            name:'全部',
            value:''
          },
          {
            name:'党员大会',
            value:1
          },
          {
            name:'支部会议',
            value:2
          },
          {
            name:'党小组会',
            value:3
          },
          {
            name:'党课',
            value:4
          },
          {
            name:'民主生活会',
            value:5
          },
          {
            name:'报告工作',
            value:6
          },
          {
            name:'党员汇报',
            value:7
          },
          {
            name:'民主评议',
            value:8
          },
          {
            name:'每周一课',
            value:9
          },
          {
            name:'党建活动',
            value:10
          },
          {
            name:'工会活动',
            value:11
          },
          {
            name:'其他',
            value:12
          },
        ],
         data:{}
      }
    },
    mounted(){
      this.getData()
    },
    methods:{
      isMenuExit(row){
            var flag = util.common.filterBtnMenu(row)
            return flag
        }, 
      enter(){
        this.$router.push({
          path:'/partyBuildingActivitiesAdd',
          query:{
            type:'2',
            id:this.$route.query.id
          }
        })
      },
      deleteByIdNew(){
        let that = this
        this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          myHttp.deleteByIdNew({
            id:this.$route.query.id
          }).then(res=>{
            console.log(res)
            if(res.data.code==200){
              this.$message({
                type: 'success',
                message: res.data.msg
              });
              that.$router.replace('/partyBuildingActivities')
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })         
        })
      },
      getData(){
        myHttp.getByIdNew({
          id:this.$route.query.id
        }).then(res=>{
          console.log(res)
          if(res.data.code==200){
            if(res.data.data.imgContent!=''){
              let imgS = res.data.data.imgContent.split(',')
              imgS.forEach((item,index)=>{
                imgS[index] = base.httpCtx+item
              })
              res.data.data.imgContent = imgS
            }else{
              res.data.data.imgContent = []
            }
            // let b = res.data.data.newsContent.replace(/\n/g,'<br>')
            // let aa = b.split('')
            //   let bb = []
            //   aa.forEach(itemA =>{
            //     if(itemA==' '){
            //       bb.push('&nbsp;')
            //     }else{
            //       bb.push(itemA)
            //     }
            //   })
            //   res.data.data.newsContent = bb.join('')
              this.typeList.forEach((itemA,indexA)=>{
                if(res.data.data.newsType==itemA.value){
                  res.data.data.newsType=itemA.name
                }
              })
            this.data=res.data.data
            console.log(this.data)
          }
        })
      },
      exit(){
        this.$router.go(-1)
      },
    }
  }
</script>

<style scoped>
  .home-box{
    width: 100%;
    height: 100%;
    background-color: rgb(245,245,245);
    padding: 10px 24px 10px 16px;
  }
  .box{
    position: relative;
    width: 100%;
    height: 96%;
    border-radius: 0px 0px 6px 6px;
    overflow: hidden;
    border-radius: 6px;
    background: #FFFFFF;
    box-shadow: 2px 2px 6px 0px rgba(77, 110, 177, 0.2);
  }
  .title{
    text-align: start;
    font-size: 16px;
    display: flex;
  }
  .title:hover{
    opacity: 0.7;
    cursor: pointer;
  }
  .box-title{
    height: 4.2vh;
    display: flex;
    justify-content: end;
    align-items: center;
    border-bottom: 2px solid #ECF0F5;
  }
  .btn1{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 46px;
    height: 26px;
    border-radius: 4px;
    box-sizing: border-box;
    border: 1px solid #D4D6D9;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    font-weight: normal;
    letter-spacing: 0em;
    color: #31373D;
    margin-right: 8px;
  }
  .btn2{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 8px;
    width: 46px;
    height: 26px;
    border-radius: 4px;
    box-sizing: border-box;
    border: 1px solid #FFA6A6;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    font-weight: normal;
    letter-spacing: 0em;
    color: #FFA6A6;
  }
  .btn1:hover,.btn2:hover{
    opacity: 0.7;
    cursor: pointer;
  }
  .imgList{
    display: flex;
  }
    .box-b{
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 16px;
    display: flex;
    height: 3vh;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;
  }
  .ll{
    height: 100%;
    display: flex;
    align-items: center;
  }
  .ll>div:nth-child(1){
    width: 82px;
    height: 100%;
    border-radius: 25px;
    background: #FA001F;
    font-family: SourceHanSansCN-Medium;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0em;
    color: #FFFFFF;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .ll>div:nth-child(2){
    margin-left: 20px;
    font-family: SourceHanSansCN-Regular;
    font-size: 16px;
    font-weight: normal;
    letter-spacing: 0em;
    color: #999999;
  }
  .ll>div:nth-child(3){
    margin-left: 20px;
    font-family: SourceHanSansCN-Regular;
    font-size: 16px;
    font-weight: normal;
    letter-spacing: 0em;
    color: #999999;
  }
  .rr{
    font-family: SourceHanSansCN-Regular;
font-size: 16px;
font-weight: normal;
letter-spacing: 0em;
color: #999999;
  }
  .box-cont{
    height: 72vh;
    overflow: auto;
  }
</style>